import React from 'react'
import { DefaultButton, Dropdown, DropdownMenuItemType } from 'office-ui-fabric-react';
import River from './filterComponents/River';
import Location from './filterComponents/Location';

const timeSeries = (props) => {
  const { plot, plotIndex, favorites, userFavorites } = props;

  let changed = false
  const applied = JSON.stringify((({ method, source, river, locations, type, alternatives }) => ({ method, source, river, locations, type, alternatives }))(plot.appliedFilters));
  const last = JSON.stringify((({ method, source, river, locations, type, alternatives }) => ({ method, source, river, locations, type, alternatives }))(plot.lastApplied));
  if(applied !== last){
    changed = true
  }
  // const { appliedFilters, lastApplied } = plot;
  // const { stats, tenth, average, fiftieth, ninetieth, min, max } = appliedFilters;
  // console.log(stats, tenth, average, fiftieth, ninetieth, min, max);
  let keyLocations = plot.availableFilters && plot.availableFilters.favorites && plot.availableFilters.favorites.map(({source, source_id, river, river_id, location, location_id}) => {
    return {
      key: `${source_id}-${river_id}-${location_id}`,
      source_id,
      river_id,
      location_id,
      text: `${location}`
    }
  });
  let userFav = userFavorites.map(({source, source_id, river, river_id, location, location_id}) => {
    return {
      key: `${source_id}-${river_id}-${location_id}`,
      source_id,
      river_id,
      location_id,
      text: `${location}`
    }
  });

  if(userFav.length === 0){
    userFav = [{
      key: 'disabled',
      text: 'No locations identified',
      disabled: true
    }]
  }

  if(!keyLocations){
    keyLocations = []
  }
  let options = [
    { key: 'myLocs', text: 'My Locations', itemType: DropdownMenuItemType.Header },
    ...userFav,
    { key: 'keyLocs', text: 'Key Locations', itemType: DropdownMenuItemType.Header },
    ...keyLocations
  ];
  const dateOptions = [];
  for (var i = 1931; i <= 2012; i++) {
    dateOptions.push(i);
  };
  let disabled = false;
  if(!plot.appliedFilters.source) disabled = true;
  if(!plot.appliedFilters.river) disabled = true;
  if(!plot.appliedFilters.locations.length) disabled = true;
  if(!plot.appliedFilters.type) disabled = true;
  if(!plot.appliedFilters.startDate) disabled = true;
  if(!plot.appliedFilters.endDate) disabled = true;
  if(plot.isLoading) disabled = true;

  return (
    <div>
      {
        favorites ? (
          <Dropdown 
            placeHolder='Select a Location'
            disabled={!plot.appliedFilters.method}
            id='location-dropdown'
            className={plot.appliedFilters.source && plot.appliedFilters.river && plot.appliedFilters.locations.join('') ? '' : 'empty'}
            selectedKey={`${plot.appliedFilters.source}-${plot.appliedFilters.river}-${plot.appliedFilters.locations.join('')}`}
            onChange={(e, option) => {
              let { source_id, river_id, location_id } = option;
              props.changeFilter({source: source_id, river: river_id, locations: [location_id]}, plotIndex, 'favorite')
            }}
            options={ options }
          />
        ) : (
          <div>
            <Dropdown
              placeHolder="Select a Source"
              disabled={!plot.appliedFilters.method}
              id="type-dropdown-filter"
              className={plot.appliedFilters.source ? '' : 'empty'}
              selectedKey={plot.appliedFilters.source}
              onChange={(e, option) => props.changeFilter({source: option.key}, plotIndex, 'source')}
              options={ plot.availableFilters.sources.map(({source_id, source}) => ({key: source_id, text: source === 'RIVER' ? 'HEC RAS' : 'RESSIM'})) }
            />
            <Dropdown
              placeHolder="Select a River"
              disabled={!plot.appliedFilters.source}
              id="type-dropdown-filter"
              onRenderOption={(props) => <River {...props} />}
              onDismiss={() => props.setMap(null)}
              className={plot.appliedFilters.river ? '' : 'empty'}
              selectedKey={plot.appliedFilters.river}
              onChange={(e, option) => props.changeFilter({river: option.key}, plotIndex, 'river')}
              options={ plot.availableFilters.rivers.map(({river_id, river}) => ({key: river_id, text: river})) }
            />
            <Dropdown
              disabled={ !plot.appliedFilters.river }
              placeHolder="Select Location"
              id="location-dropdown"
              onRenderOption={(props) => <Location {...props} river={plot.appliedFilters.river} favorites={userFav}/>}
              className={plot.appliedFilters.locations && plot.appliedFilters.locations.length ? '' : 'empty'}
              selectedKey={ plot.appliedFilters.locations }
              onChange={(e, option) => props.changeFilter({locations: [option.key]}, plotIndex, 'location')}
              options={ plot.availableFilters.locations.map(({location_id, location, favorite}) => ({key: location_id, location_id, text: location})) }
            />
          </div>
        )
      }
      <Dropdown
        placeHolder="Select a Type"
        className={plot.appliedFilters.type ? '' : 'empty'}
        disabled={ !plot.appliedFilters.locations.length }
        id="type-dropdown-filter"
        selectedKey={plot.appliedFilters.type}
        onChange={(e, option) => {
          props.changeFilter({type: option.key}, plotIndex, 'type');
          props.editChartY({title: option.text}, plotIndex);;
        }}
        options={ plot.availableFilters.types.map(({type_id, type, unit}) => ({key: type_id, text: `${type} - (${unit})`})) }
      />
      <DefaultButton
        className={`apply-filter${(changed && !disabled) ? ' changed' : ''}`}
        disabled={disabled}
        text="Apply"
        primary
        onClick={ () => props.applyFilters({...plot.appliedFilters}, plotIndex) }
      />
      { (changed && !disabled) ? (<div className='changed-warning'>Filters have changed since last applied. Click apply to update data.</div>) : null }
    </div>
  )
}

export default timeSeries;



// WEBPACK FOOTER //
// ./src/components/panel/items/filters/timeSeries.js